














































import Vue from "vue";
import { defineComponent } from "@vue/composition-api";
// @ts-ignore
import { VCard, VContainer, VForm, VRow, VCol } from "vuetify/lib";

import { Dictionary, FormFields, FormValues } from "@/types";
import { castComponent } from "@/lib/helpers";
import FieldPrinter from "@/components/FieldPrinter";

Vue.component("VCard", castComponent(VCard));
Vue.component("VContainer", castComponent(VContainer));
Vue.component("VForm", castComponent(VForm));
Vue.component("VRow", castComponent(VRow));
Vue.component("VCol", castComponent(VCol));
Vue.component("FieldPrinter", FieldPrinter);

export default defineComponent({
  name: "BaseFlexForm",
  props: {
    valid: { type: Boolean, default: false },
    fields: { type: Array as () => FormFields, required: true },
    flexClass: { type: String },
    values: { type: Object as () => FormValues, required: true },
    fieldsErrors: { type: Object as () => Dictionary<string[]>, default: () => ({}) },
  },
  model: {
    event: "input",
    prop: "values",
  },
});
